import React from 'react';

const ReviewSummaryComponent = ({ reviewSummaryText, reviewSummaryKeyThemes, reviewSummaryTotalTestimonials, isReviewSummaryEnabled, fontStyle, isDarkModeEnabled }) => {
  const keyThemes = (reviewSummaryKeyThemes && Array.isArray(reviewSummaryKeyThemes)) ? reviewSummaryKeyThemes : [];

  if (!isReviewSummaryEnabled || (!reviewSummaryText && !keyThemes.length && !reviewSummaryTotalTestimonials)) {
    return null;
  }

  const titleTextClass = isDarkModeEnabled ? 'text-white' : 'text-gray-900';
  const metaTextClass = isDarkModeEnabled ? 'text-gray-300' : 'text-gray-600';
  const summaryTextClass = isDarkModeEnabled ? 'text-gray-100' : 'text-gray-700';
  const highlightTitleClass = isDarkModeEnabled ? 'text-gray-100' : 'text-gray-800';
  const highlightTextClass = isDarkModeEnabled ? 'text-gray-300' : 'text-gray-600';
  const summaryBoxClass = isDarkModeEnabled ? 'border border-gray-700' : 'border border-blue-50';

  return (
    <div className="px-6 pb-8 pt-0 relative overflow-hidden">
      {/* Decorative elements */}
      
      <div className="relative">
        {/* Header */}
        <div className="flex items-center mb-4">
          <div>
            <h3 className={`text-xl font-bold ${titleTextClass} ${fontStyle && fontStyle !== '' ? `font-${fontStyle}` : ''}`}>AI Review Summary</h3>
            <div className="flex items-center">
              <div className="flex">
                {[1, 2, 3, 4, 5].map((star) => (
                  <svg key={star} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                  </svg>
                ))}
              </div>
              <span className={`ml-2 text-sm ${metaTextClass} ${fontStyle && fontStyle !== '' ? `font-${fontStyle}` : ''}`}>from {reviewSummaryTotalTestimonials} testimonials</span>
            </div>
          </div>
        </div>
        
        {/* Summary */}
        <div className={`bg-opacity-70 backdrop-filter backdrop-blur-sm rounded-lg p-4 mb-4 shadow-sm ${summaryBoxClass}`}>
          <p className={`${summaryTextClass} leading-relaxed ${fontStyle && fontStyle !== '' ? `font-${fontStyle}` : ''}`}>{reviewSummaryText}</p>
        </div>
        
        {/* Key Themes */}
        {keyThemes.length > 0 && (
          <div>
            <h4 className={`text-sm font-bold ${highlightTitleClass} mb-3 flex items-center ${fontStyle && fontStyle !== '' ? `font-${fontStyle}` : ''}`}>
              Key Highlights:
            </h4>
            <ul className="flex flex-wrap gap-x-6 gap-y-2">
              {keyThemes.map((point, index) => (
                <li key={index} className={`flex items-center text-sm ${highlightTextClass} ${fontStyle && fontStyle !== '' ? `font-${fontStyle}` : ''}`}>
                  <svg className="w-4 h-4 text-green-500 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                  </svg>
                  {point}
                </li>
              ))}
            </ul>
          </div>
        )}
      
      </div>
    </div>
  );
};

export default ReviewSummaryComponent;
